import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import TrashcanIcon from '../../icons/components/TrashcanIcon.vue';
import { VButton } from '../../common/components';
import FormElement from './FormElement.vue';
import { getState } from '../helpers/formHelpers';
import { RepeatModel, FormModel, FormEvent, FormActionEvent, FormAction } from '../interfaces/form';
import { FormValidation } from '../interfaces';

/**
 * Repeat Form component
 *
 * DEPRECATED - currently, no repeat forms are used, and repetition of entities is handled outside of the form system
 * Kept here pending removal of repeat form functionality from form model constructors
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'RepeatForm',
  props: {
  form: {
    type: Object as PropType<FormValidation<FormModel[]>>,
    required: true,
  },

  model: {
    type: Object as PropType<RepeatModel>,
    required: true,
  },
},
  emits: {
  'form-event': (_event: FormEvent<any>) => true,
},
  setup(__props, { emit }) {

const props = __props;





const elementTitlePlaceholder = computed(() => getState(props.model, 'multipleTitlePlaceholder', ''));

const multipleClass = computed(() => getState(props.model, 'multipleClass', ''));

const itemName = computed(() => getState(props.model, 'itemName', ''));

function isOpen(model: FormModel | RepeatModel) {
  return getState(model, 'open') || props.form.$model.length <= 1;
}

function elementTitle(model: FormModel) {
  const titleField = props.model.$state.multipleTitleField;
  if (typeof titleField === 'string') {
    return null;
  }
  if (typeof titleField === 'function') {
    return props.model.$state.multipleTitleField(model).trim();
  }
  return null;
}

function onChildEvent(event: FormEvent) {
  if (event.event === 'form-action') {
    if ((event as FormActionEvent).action.name === 'remove-item-internal') {
      removeItem(props.form.$model.indexOf(event.model as FormModel));
    }
  }
  emit('form-event', event);
}

function addItem() {
  if (props.form.$model) {
    props.form.$model.push(props.model.$constructor());
  } else {
    props.form.$model = [props.model.$constructor()];
  }
}

function removeItem(index: number) {
  props.form.$model.splice(index, 1);
}

function onFormAction(action: FormAction) {
  setTimeout(() => {
    emit('form-event', {
      field: props.form,
      model: props.model,
      event: 'form-action',
      action,
    } as FormEvent<FormModel[]>);
  });
}

return { __sfc: true,props, emit, elementTitlePlaceholder, multipleClass, itemName, isOpen, elementTitle, onChildEvent, addItem, removeItem, onFormAction, TrashcanIcon, VButton, FormElement }
}

})